// `?email=` arrives from the paid-traffic landing page. It is a hint for
// Google's account chooser (login_hint) and a join key back to the form
// submit, never an identity: the Google account stays the source of truth.

export const PREFILL_EMAIL_PARAM = "email";

const MAX_EMAIL_LENGTH = 254;
const EMAIL_RE = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/;

/** Returns the trimmed, lowercased address, or null when it does not look
 *  like an email. Callers must never log the value. */
export function normalizePrefillEmail(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const email = raw.trim().toLowerCase();
  if (email.length === 0 || email.length > MAX_EMAIL_LENGTH) return null;
  return EMAIL_RE.test(email) ? email : null;
}
